<template>
	<div class="contactBox">
		<div class="contactBox-banner">
			<div class="contactBox-banner-in">
				<div class="contactBox-banner-in-logo"></div>
			</div>
		</div>

		<div class="contactBox-nr">
			<div class="contactBox-nr-map">
				<div class="contactBox-nr-map-left">
					<img :src="$store.state.website + $store.state.contact.image" style="width:100%;height: 406px;" />
				</div>
				<div class="contactBox-nr-map-right">
					<div class="contactBox-nr-map-right-a">{{$store.state.contact.address}}</div>
					<div class="contactBox-nr-map-right-a">{{$store.state.contact.tellphone}}</div>
					<div class="contactBox-nr-map-right-a">{{$store.state.contact.fax}}</div>
					<div class="contactBox-nr-map-right-a">{{$store.state.contact.phone}}</div>
					<div class="contactBox-nr-map-right-b">
						<img :src="$store.state.website + $store.state.contact.codeimage" style="width:100%" />
					</div>
					<div class="contactBox-nr-map-right-c">合作洽谈</div>
				</div>
			</div>

			<div class="contactBox-nr-tit">快速提交您的需求</div>
			<div class="contactBox-nr-input-a">
				<div class="contactBox-nr-input-a-item">
					<input type="text" v-model="messageTitle" placeholder="留言标题" />
				</div>
				<div class="contactBox-nr-input-a-item">
					<input type="text" v-model="messageContact" placeholder="联系邮箱 / 手机号" />
				</div>
			</div>
			<div class="contactBox-nr-input-b">
				<textarea v-model="messageContent" placeholder="留言内容..." style="resize: none;"></textarea>
			</div>
			<div class="contactBox-nr-input-btn" @click="tapBtn">提交</div>
		</div>


		<div style="height:100px"></div>
		<PageBottom />
	</div>
</template>

<script>
	import PageBottom from '@/components/PageBottom.vue'
	export default {
		name: 'contactBox',
		components: {
			PageBottom
		},
		data() {
			return {
				messageTitle: '',
				messageContact: '',
				messageContent: '',
			}
		},
		mounted() {
			window.pageYOffset = 0;
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0
		},
		methods: {
			tapBtn() {
				let that = this;
				// console.log(e);
				// console.log(that.messageTitle);
				// console.log(that.messageContact);
				// console.log(that.messageContent);
				let aaa = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
				let bbb = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
				
				if (that.messageTitle.match(/^[ ]*$/)) {
					alert('留言标题不能为空');
					return
				}
				if(that.messageContact.includes('@')){ //是邮箱
					if(!bbb.test(that.messageContact)){
							alert('邮箱不正确')
							return
					}
				}else{
					if (!aaa.test(that.messageContact)) {
						alert('手机号不正确')
						return
					}
				}
				if (that.messageContent.match(/^[ ]*$/)) {
					alert('留言内容不能为空');
					return
				}
				console.log('全部满足');
				let messageTitle = that.messageTitle;
				let messageContact = that.messageContact;
				let messageContent = that.messageContent;
				console.log(messageTitle, messageContact, messageContent);
				that.$axios.post('http://www.sy-eray.com/index.php/api/demo/message'
				// ?title=' + messageTitle + '&phone=' + messageContact +
				// 	'&text=messageContent'
					, {
						'title':messageTitle,
						'phone':messageContact,
						'text':messageContent,
					}).then(function(response) {
					console.log('response', response.data.data);
					alert('留言成功，我们会尽快与您联系');
					that.messageTitle = '';
					that.messageContact = '';
					that.messageContent = '';

				}).catch(function(error) {
					console.log(error);
					// alert('网络繁忙请稍后再试！')
					
					alert('留言成功，我们会尽快与您联系');
					that.messageTitle = '';
					that.messageContact = '';
					that.messageContent = '';
				});



			},

		}
	}
</script>

<style>
	.contactBox-banner {
		width: 100%;
		height: 480px;
		background-image: url(../assets/lianxiwmBG.jpg);
		background-size: 100% 100%;
		margin-bottom: 100px;
		box-sizing: border-box;
	}

	.contactBox-banner-in {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		position: relative;
	}

	.contactBox-banner-in-logo {
		width: 472px;
		height: 70px;
		background-image: url(../assets/lianxiwmTit.png);
		background-size: 100% 100%;
		position: absolute;
		top: 250px;
		left: 0;
	}

	.contactBox-nr {
		width: 1200px;
		height: auto;
		/* background: red; */
		margin: 0 auto;
	}

	.contactBox-nr-map {
		width: 100%;
		height: 406px;
		/* background-image: url(../assets/dizhiMap.png); */
		/* background-size: 100% 100%; */
		/* box-shadow: 0px 0px 20px #e6e6e8; */
		/* background: red; */

	}

	.contactBox-nr-map-left {
		width: 798px;
		height: 406px;
		box-shadow: 0px 0px 20px #e6e6e8;
		/* background: pink; */
		/* transition: all .5s; */
		/* background-image: url(../assets/lianxiwomenBG.png); */
		background-size: 100% 100%;
		float: left;
		overflow: hidden;
		transition: all .5s;
	}

	.contactBox-nr-map-right {
		width: 382px;
		height: 406px;
		box-shadow: 0px 0px 20px #e6e6e8;
		background: #ffffff;
		/* transition: all .5s; */
		float: right;
		padding: 40px 30px;
		box-sizing: border-box;
		font-size: 16px;
		color: #666666;
		line-height: 36px;
		font-weight: bold;
		position: relative;
		transition: all .5s;
	}

	.contactBox-nr-map-right-b {
		width: 108px;
		height: 108px;
		/* background: pink; */
		position: absolute;
		bottom: 76px;
		left: 30px;
	}

	.contactBox-nr-map-right-c {
		position: absolute;
		bottom: 40px;
		left: 52px;
		font-size: 14px;
		color: #888888;
		font-weight: 0;
	}

	.contactBox-nr-map-left:hover {
		transform: translateY(-10px);
	}
	.contactBox-nr-map-right:hover {
		transform: translateY(-10px);
	}

	.contactBox-nr-tit {
		width: 100%;
		height: auto;
		font-size: 28px;
		color: #52dedb;
		font-weight: bold;
		text-align: center;
		padding-top: 100px;
		box-sizing: border-box;
	}

	.contactBox-nr-input-a {
		width: 100%;
		height: 40px;
		margin-top: 50px;
		box-sizing: border-box;
	}

	.contactBox-nr-input-a-item {
		width: 580px;
		height: 100%;
		line-height: 40px;
		font-size: 16px;

		/* background: pink; */
		float: left;
		margin-right: 20px;
	}

	.contactBox-nr-input-b {
		width: calc(100% - 20px);
		height: 200px;
		/* background: red; */
		margin-top: 20px;
		box-sizing: border-box;
	}

	.contactBox-nr-input-btn {
		width: 120px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		color: #ffffff;
		background: #fed24f;
		margin: 0 auto;
		margin-top: 20px;
		box-sizing: border-box;
		cursor: pointer;
		border-radius: 8px;
		transition: all .5s;
	}

	.contactBox-nr-input-btn:hover {
		transform: scale(1.1);
		/* transform: translateY(10px); */
	}

	input {
		width: 100%;
		height: 100%;
		border: 1px solid #E0E0E0;
		box-sizing: border-box;
		padding: 0 20px;
		color: #666666;
	}

	textarea {
		width: 100%;
		height: 100%;
		border: 1px solid #E0E0E0;
		box-sizing: border-box;
		padding: 20px;
		color: #666666;
	}
</style>
